export enum RequestState {
    NOT_ASKED,
    LOADING,
    SUCCESS,
    ERROR
}


// WEBPACK FOOTER //
// ./src/models/RequestState.ts